import React, { useState } from "react";
import styles from "./Subnav.module.scss";
import { Right } from "../Icons";

const Details = ({ record, close, updateItem, deleteItem }) => {
  return (
    <div className={styles.records}>
      <a
        href="#0"
        onClick={(e) => {
          e.preventDefault();
          close(false);
        }}
      >
        X
      </a>
      <div className="record__details">
        <div className={styles.promotion__wrapper}>
          <a
            href="#0"
            className={styles.promotionBtn}
            onClick={(e) => {
              const id = record.id;
              e.preventDefault();
              updateItem(record, "review");
              deleteItem(id);
            }}
          >
            Promote <Right color="#FFF" />
          </a>
        </div>
        <h5>Title</h5>
        <p>{record.title}</p>
        <hr />

        <h5>Description</h5>
        <p>{record.description}</p>
        <hr />
      </div>
    </div>
  );
};
const Bl = ({ records, deleteItem, setBl, setBackground, updateItem }) => {
  const [detail, setDetail] = useState(false);
  const [record, setRecord] = useState({});

  return (
    <div className={styles.subnav}>
      <a
        href="#0"
        className={styles.closeBtn}
        onClick={(e) => {
          e.preventDefault();
          setBl(false);
          setBackground({
            backgroundImage:
              "url('https://impactrepublic.github.io/heliox/images/home-bg.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          });
        }}
      >
        X
      </a>
      {detail && (
        <Details
          record={record}
          close={setDetail}
          updateItem={updateItem}
          deleteItem={deleteItem}
        />
      )}
      <div className={styles.title}>
        <span className={styles.bl}>BL</span>
        <h1>Back Log</h1>
        <p>
          Stay productive with a powerful project management tool that will help
          you get more done in less time. Backlog features helps to prevent the
          backlogs of problems from piling up. In a world where at any moment
          your cognitive function can change.
        </p>

        <p>
          The BackLog Feature will ensure that you always know what needs your
          attention first so you can focus on the implementation more
          efficiently.
        </p>
      </div>

      <ul>
        {records.map((item, idx) => {
          const date = new Date(item.startDate);
          return (
            <li
              key={idx}
              onClick={(e) => {
                e.stopPropagation();
                setDetail(true);
                setRecord(item);
              }}
            >
              <h5>{item.title}</h5>
              <p>
                {item.description}
                <a
                  href="#0"
                  onClickCapture={(e) => {
                    e.preventDefault();
                    deleteItem(item.id);
                  }}
                >
                  X
                </a>
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Bl;
